import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  OnChanges,
  SimpleChanges,
  OnDestroy,
  ChangeDetectionStrategy
} from "@angular/core";

export interface ITableQuery {
  total: number;
  pageIndex: number;
  pageSize: number;
  sortName?: string;
  sortValue?: string;
  parameter?: any;
  keyWord:string;
}
export interface ITableHeader {
  key?: any;
  name?: string;
  //pop?: string;
  width?: number;
  minWidth?: number;
  filterList?: any;
  checkboxable?: boolean;
  sortable: boolean;
  hiden?: boolean,
  action?: boolean;
  [additionalProperties: string]: any;
}

export interface ITableButton {
  type?: string;
  text?: string;
}



@Component({
  selector: "kreform-private-table",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.less"]
})
export class KreFormPrivateTable  implements OnInit, OnChanges, OnDestroy {
   
  @Input() set tableIndex(value:number){
    this.query.pageIndex=value;
  }
  get tableIndex(){
    return this.query.pageIndex;
  }
  
  @Input() set tableSize(value:number){
    this.query.pageSize=value;
  }
  get tableSize(){
    return this.query.pageSize;
  }
  
  @Input() set tableTotal(value:number){
    this.query.total=value;
  }
  get tableTotal(){
    return this.query.total;
  }

  //tableId
  @Input() id: string="";

  //是否要多选
  @Input() check = false;

  //是否有操作列0 没有操作列；1 多个操作按钮 2 选择
  @Input() action = 0;

  //table 头部信息
  @Input()
  set header(value: ITableHeader[]) {
    if (value != null && value.length > 0) {
      value.forEach(item => {
        item.prop = item.key;
        if (item.checkboxable) {
          item.name="";
          item.width=50;
          item.canAutoResize = false;
          item.resizeable = false;
          item.frozenLeft = true;
          item.checkboxable = true;
          item.headerCheckboxable = true;
        }
        if(item.action){ 
          item.frozenRight=true;
          item.canAutoResize=false;
          item.resizeable=false;
        }
        this._headerData.push(item);
      });
    }
  }
  get header() {
    return this._headerData;
  }

  //table 行数据
  @Input()
  set body(value: any[]) {
    this.listData = value;
    if(this.listData==null || this.listData.length==0){
      this.tableScroll.y="0px";
    }else{
      this.tableScroll.y="332px";
    }
  }

  //按钮列表
  @Input() buttonlist: ITableButton[] = [];

  //默认选中Id
  @Input()
  set checkid(value: any[]) {
    this.listDataSelectedList=[];
    if (value != null && value.length > 0) {
      value.forEach(item => {
        this.listDataCheckedId[item.id] = true;
        this.listDataSelectedList.push(item);
      });
    }
  }

  //选中事件
  @Output() checkChangeEvent: EventEmitter<any> = new EventEmitter();
  //翻页事件
  @Output() pageIndexEvent: EventEmitter<any> = new EventEmitter();
  //排序事件
  @Output() orderChangeEvent: EventEmitter<any> = new EventEmitter();
  //过滤事件
  @Output() filterChangeEvent: EventEmitter<any> = new EventEmitter();
  //操作事件
  @Output() buttonAction: EventEmitter<any> = new EventEmitter();


  checkIds: string[] = [];
  _headerData:any[] = [];

  isAllChecked = false;
  isIndeterminate = false; 

  listData: any[] = [];
  listDataCheckedId: { [key: string]: boolean } = {};
  listDataSelectedList: any[] = [];

  query: ITableQuery = {
    total: 0,
    pageIndex:1,
    pageSize: 15,
    sortName: "",
    sortValue: "",
    keyWord:""
  }
  tableScroll = {
    y: '332px'
  };
 
  constructor() {}
 

  ngOnChanges(changes: SimpleChanges) {}
 

  ngOnInit() {

  }

  ngOnDestroy() {

  }

  //全选|全不选
  setCheckAll(value: boolean): void {
    this.listData.forEach(item => (this.listDataCheckedId[item.id] = value));
    this.setCheckStatus();
  }

  //设置某个选择|取消选中
  setCheckStatus(): void { 
    this.isAllChecked = this.listData.every(item => this.listDataCheckedId[item.id]);
    this.isIndeterminate = this.listData.some(item => this.listDataCheckedId[item.id]) && !this.isAllChecked;
    this.saveSelected();
  }
  
 
  //点击查询
  queryChange()
  {
    this.pageIndexEvent.emit(this.query);  
  }

  //点击翻页
  pageIndexChange(e:number) {
    this.query.pageIndex = e;
    this.pageIndexEvent.emit(this.query);
  }

  //点击排序
  tableSort(sort: { key: string; value: string }): void {
    this.query.sortName = sort.key;
    this.query.sortValue = sort.value;
    this.orderChangeEvent.emit(this.query);
  } 

  //单击选中
  itemSelectChange(event:any){
    this.listDataSelectedList.shift();
    this.listDataSelectedList.push({
      "id":event.id,
      "name":event.name
    });
    this.checkChangeEvent.emit(this.listDataSelectedList);
  }
 
  //保存选中
  saveSelected(){ 
    Object.keys(this.listDataCheckedId).forEach(id => {
      let value = this.listDataCheckedId[id];
        if(value){
         if(!this.listDataSelectedList.some(item=>{return item.id==id})){
          this.listData.forEach((item,index,object)=>{
            if(item.id==id){
              this.listDataSelectedList.push({
                id:item.id,
                name:item.name
              });
            }
          });
         }
        }
        else{
          this.listDataSelectedList.forEach((item,index,object)=>{
            if(item.id==id){
              object.splice(index,1);
            }
          });
        }
    });
    
    this.checkChangeEvent.emit(this.listDataSelectedList); 
  }
  
  selectAllClear(){
    this.isAllChecked = false;
    this.isIndeterminate = false; 
    this.listDataCheckedId={};
    this.listDataSelectedList=[]; 
  }

  selectClearById(id:any){
    this.listDataCheckedId[id]=false;
    this.setCheckStatus();
  }
}
